import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useWindowSize } from "react-use";

import Confetti from "react-confetti";
import {
    selectIsCelebrationActive,
    stopCelebration,
} from "../lib/scraper.slice";

export function Celebration() {
    const { width, height } = useWindowSize();
    const is_celebration_active = useSelector(selectIsCelebrationActive);
    const dispatch = useDispatch();

    const [pieces, setPieces] = useState(0);

    useEffect(() => {
        if (!is_celebration_active) return;

        setPieces(1000);

        let fadeInterval: NodeJS.Timeout;
        const fadeStart = setTimeout(() => {
            fadeInterval = setInterval(() => {
                setPieces((prev) => {
                    if (prev <= 30) {
                        clearInterval(fadeInterval);
                        dispatch(stopCelebration());
                        return 0;
                    }
                    return prev - 30;
                });
            }, 100);
        }, 1000);

        return () => {
            clearTimeout(fadeStart);
            if (fadeInterval) clearInterval(fadeInterval);
        };
    }, [is_celebration_active, dispatch]);

    return (
        <Confetti
            width={width}
            height={height}
            numberOfPieces={pieces}
            gravity={0.3}
            recycle={true}
            style={{
                zIndex: 9999,
                pointerEvents: "none",
                position: "fixed",
                top: 0,
                left: 0,
            }}
        />
    );
}